import React from 'react';
import { useRecoilState } from 'recoil';

import { onboardingTestIDs } from '@constants';
import { screenReaderEnabledState } from '@store';

import { SubscriberSignInContent } from './components/SubscriberSignInContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

const testIDs = onboardingTestIDs.subscriberSignIn;

export const SubscriberSignInPage = () => {
  const [screenReaderEnabled] = useRecoilState(screenReaderEnabledState);

  return (
    <TWCPage
      childIds={[
        testIDs.subscriberSignIn.subscriberSection,
        testIDs.subscriberSignIn.emailInput,
        testIDs.subscriberSignIn.continueButton,
        testIDs.cableSignIn.cableSection,
        testIDs.cableSignIn.newCodeButton,
      ]}
      firstFocus={
        screenReaderEnabled ? testIDs.subscriberSignIn.subscriberSection : testIDs.subscriberSignIn.emailInput
      }
      pageID={onboardingTestIDs.pages.subscriberSignInPage}
    >
      <SubscriberSignInContent />
    </TWCPage>
  );
};
